import { useEffect, useState } from "react";
import styles from "./ProfileSection.module.css";
import edit from "../../../../assets/edit.png";
import { useSelector } from "react-redux";
import { PhotoCamera, CameraAlt as CameraAltIcon } from "@mui/icons-material";
import { Button, IconButton, Avatar, Box, Typography } from "@mui/material";
import defaultProfilePic from "@/assets/default-icon.jpg";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { setAuthInfo } from "@/redux/auth/auth.slice";
// import ToastService from "@/service/toaster.servive";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import customerAuthService from "@/service/auth.service/customer.auth.service";
import ToastService from "@/service/toaster.service";
import { ToastContainer } from "react-toastify";





const NameFields = ({ firstName, lastName }) => {
  return (
    <>
      <div className={styles.nameLabels}>
        <label>First Name</label>
        <label>Last Name</label>
      </div>
      <div className={styles.nameInputs}>
        <span className={styles.firstName}>{firstName || "N/A"}</span>
        <span className={styles.lastName}>{lastName || "N/A"}</span>
      </div>
    </>
  );
};

const ProfileSection = () => {
  const [user, setUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    password: "",
    profile_picture: "",
  });
  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    complexity: false,
    strength: "Weak",
  });

  const token = localStorage.getItem("access_token");
  const userId = useSelector((state) => state.auth.auth._id);
  const dispatch = useDispatch();

  const handleEdit = () => { setIsEditing(true); };



  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
      setFormData((prev) => ({
        ...prev,
        profile_picture: file,
      }));
    }
  };


  const getUserData = async () => {
    try {
      const data = await customerAuthService.fetchUserData(userId, token);
      setUser(data);
      setFormData({
        firstName: data?.first_name || "",
        lastName: data?.last_name || "",
        password: "", // Ensure the password field is initially empty
        profile_picture: data?.profile_picture || null,
      });
      setPreviewImage(data?.profile_picture?.file_url || null);
    } catch (err) {
      console.log("Error in ProfileSection:", err);
    }
  };

  useEffect(() => {
    getUserData();
  }, [userId, token]);

  const handleCancel = () => {
    setIsEditing(false);
    setFormData({
      firstName: user?.first_name || "",
      lastName: user?.last_name || "",
      password: "", // Reset the password input
      profile_picture: user?.profile_picture || null,
    });
    setPreviewImage(user?.profile_picture?.file_url || null);
  };

  const handleSave = async () => {
    try {
      const formDataObj = new FormData();

      formDataObj.append("first_name", formData.firstName);
      formDataObj.append("last_name", formData.lastName);

      if (formData.password) {
        formDataObj.append("password", formData.password);
      }

      if (formData.profile_picture instanceof File) {
        formDataObj.append("profile_picture", formData.profile_picture);
      }

      const response = await customerAuthService.updateUserData(userId, formDataObj);
      if (response?.status == true) {
        dispatch(setAuthInfo({ ...response.data.data, role: "customer", id: response.data.data._id, }));
        setUser(response.data.data);
        setIsEditing(false);
        ToastService.success("Details Updated Successfully")
      }
    } catch (error) {
      console.error("Failed to update user:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate password while typing
    if (name === "password") { validatePassword(value); }
  };

  const validatePassword = (value) => {
    const hasLength = value.length >= 8;
    const hasSpecialChar = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/.test(value);

    let strength = "Weak";
    if (hasLength && hasSpecialChar) {
      strength = value.length > 12 ? "Strong" : "Medium";
    }

    setPasswordValidation({
      length: hasLength,
      complexity: hasSpecialChar,
      strength: strength,
    });
  };

  // Only enable the save button if the password is valid when provided

  const isPasswordValid = formData.password ? (passwordValidation.length && passwordValidation.complexity) : true;
  const isFormValid = formData.firstName && formData.lastName && isPasswordValid;

  return (
    <>
    <section className={styles.profileSection}>
      <div className={styles.profileContainer}>
        <div className={styles.imageWrapper}>
          <Box
            sx={{
              pt: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              pr: 15
            }}
          >
                  <Avatar
                    src={previewImage || defaultProfilePic}
                    alt="Profile Picture"
                    sx={{ width: 150, height: 150, mb: 0 }}
                  />

            {isEditing ? (
              <IconButton
                component="label"
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 100,
                  backgroundColor: "rgba(249, 249, 249, 0.85)",
                  borderRadius: "50%",
                  boxShadow: 8,
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.83)",
                    boxShadow: 2,
                  }
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
                <CameraAltIcon sx={{ color: "#5e5acf" }} />
              </IconButton>
            ) : null}
            
          </Box>
        </div>
        {!isEditing ? (
          <button onClick={handleEdit}>
            <div className={styles.editIconWrapper}>
              <img src={edit} alt="Edit" className={styles.editIcon} />
            </div>
          </button>
        ) : null}
      </div>

      {isEditing ? (
        <>
          <div className={styles.nameLabels}>
            <label>First Name</label>
            <label>Last Name</label>
          </div>
          <div className={styles.nameInputs}>
            <input
              label="First Name"
              name="firstName"
              className={styles.firstName}
              value={formData.firstName}
              onChange={handleChange}
              
            />
            <input
              label="Last Name"
              name="lastName"
              className={styles.lastName}
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>
          {/* Show email as a static field */}
          <label className={styles.email}>Email</label>
          <div className={styles.emailField}>{user?.email || "N/A"}</div>

          {/* Password input for updating the password */}
          <label className={styles.email}>Update New Password</label>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <input
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              className={styles.emailField}
              value={formData.password}
              onChange={handleChange}
            />
            <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </Box>


          {/* Password Validation Feedback */}
          <Box className="password-validation" sx={{ p: 1 }}>
            <Typography variant="body2" className="validationtext">
              <span style={{ color: passwordValidation.length ? "green" : "red", }}>
                {passwordValidation.length ? "✓" : "✗"}
              </span>{" "}At least 8 characters
            </Typography>

            <Typography variant="body2" className="validationtext">
              <span style={{ color: passwordValidation.complexity ? "green" : "red", }}>
                {passwordValidation.complexity ? "✓" : "✗"}
              </span>{" "}Letters, numbers & special characters (e.g. ~!@#$%^&)
            </Typography>

            <Typography variant="body2" className="validationtext">
              <span
                style={{
                  color: passwordValidation.strength === "Strong" ? "green" : passwordValidation.strength === "Medium" ? "orange" : "red",
                }}>
                {passwordValidation.length ? "✓" : "✗"}
              </span>{" "}Password Strength: {passwordValidation.strength}
            </Typography>
          </Box>

          <div className={styles.buttonWrapper}>
          <Button
            variant="contained"
            className={styles.savebtn}
            onClick={handleSave}
            disabled={!isFormValid}
            style={{
              backgroundColor: isFormValid ? "#5e5acf" : "#d3d3d3",
              color: isFormValid ? "white" : "gray",
              cursor: isFormValid ? "pointer" : "not-allowed",
            }}
          >
            Save
          </Button>
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </>
      ) : (
        <>
          <NameFields firstName={user?.first_name} lastName={user?.last_name} />
          <label className={styles.email}>Email</label>
          <div className={styles.emailField}>{user?.email || "N/A"}</div>
          <label className={styles.password}>Password</label>
          <div className={styles.passwordField}>*******</div>
        </>
      )}
    </section>
    </>
  );
};

export default ProfileSection;
